<ion-content [fullscreen]="true">
  <div style="display: flex; flex-direction: column; position: relative;">
    <ion-icon (click)="modalCtrl.dismiss()"
      style="cursor: pointer; font-size: 35px; top: 10px; right: 10px; position: absolute; z-index: 2;"
      name="close-outline"></ion-icon>

    <img
      [src]="custom_key === true ? 'https://storage.googleapis.com/altomate-picture/popup/instant_resolution_pop.png' : 'https://storage.googleapis.com/altomate-picture/popup/resolution_pop.png'"
      alt="Resolution popup">

    <div (click)="modalCtrl.dismiss()" class="body-md-semibold"
      style="margin-top: 12px; width: 100%; padding: 12px 0; background-color: var(--green); color: white; display: flex; justify-content: center;">
      READ
    </div>

  </div>
</ion-content>